import { Box, Button, Stack } from "@mui/material";
import { useEffect, useState } from "react";
import api, { RetailerDto, RetailerProductDto } from "../../../api";
import { DefaultMessageDialogOptions, MessageDialog, MessageDialogButton, MessageDialogButtons, MessageDialogIcon, MessageDialogOptions, notif } from "../../utils";
import { RetailerProductDialog, RetailerProductDialogAction } from "./RetailerProductDialog";
import { RetailerProductsGrid } from "./RetailerProductsGrid";

export interface RetailerProductsTabPageProps {
  retailer?: RetailerDto | null;
}

export const RetailerProductsTabPage = (props: RetailerProductsTabPageProps) => {
  const { retailer } = props;

  const [selected, setSelected] = useState<RetailerProductDto[]>([]);
  const [action, setAction] = useState<RetailerProductDialogAction>({ open: false });
  const [message, setMessage] = useState<MessageDialogOptions<void>>(DefaultMessageDialogOptions<void>());

  const onRowsSelected = (rows: RetailerProductDto[]) => {    
    setSelected(rows);
  };
  const onAdd = () => {
    if (retailer) {
      setAction({ open: true, retailer, productId: "" });
    }
  };
  const onEdit = () => {
    if (selected?.length === 1) {
      setAction({ open: true, retailer: selected[0].retailer, productId: selected[0].productId });
    }
  };
  const onDelete = () => {
    if (selected?.length > 0) {
      setMessage({
        open: true,
        title: "DELETE RETAILER PRODUCT",
        buttons: MessageDialogButtons.YesNo,
        icon: MessageDialogIcon.Question,
        content: selected.length === 1 ? `Do you want to delete retailer product '${selected[0].product?.sku}'?` : `Do you want to delete ${selected.length} retailer products?`,
      });
    }
  };
  const onMessageSubmit = async (button: MessageDialogButton) => {
    if (button === MessageDialogButton.Yes && retailer?.id && selected?.length > 0) {
      try {
        const ids = selected.map(p => p.productId!);
        await api.retailerProduct.delete(retailer.id, { ids } as any);
      } catch (err) {
        notif(err, "error");
      }
    }
    setMessage({ open: false });
  };
  const onDialogSubmit = (dto: RetailerProductDto | null) => {
    setAction({ open: false });
    setSelected([]);
  };

  useEffect(() => {

  }, [selected]);

  return (
    <Box>
      <RetailerProductsGrid retailerId={retailer?.id || ""} onRowsSelected={onRowsSelected} />
      <Box sx={{ p: 1 }} />
      <Stack spacing={2} direction="row">
        <Button variant="contained" disabled={!retailer?.id} onClick={onAdd}>
          Add
        </Button>
        <Button variant="contained" disabled={selected.length !== 1} onClick={onEdit}>
          Edit
        </Button>
        <Button variant="contained" disabled={selected?.length < 1} onClick={onDelete}>
          Delete
        </Button>
      </Stack>
      <RetailerProductDialog action={action} onSubmit={onDialogSubmit} />
      <MessageDialog options={message} onSubmit={onMessageSubmit} />
    </Box>
  );
};
